/* eslint-disable react-hooks/exhaustive-deps */
import "rc-slider/assets/index.css"

import React, { MouseEvent, useEffect, useState } from "react"

import {
  getPlayerMute,
  getPlayerVolume,
  setPlayerMute,
  setPlayerVolume,
} from "@shared/modules"

import { Player } from "live/modules"
import Slider from "rc-slider"

interface Props {
  player: Player
}

export default function Volume({ player }: Props) {
  const [volume, setVolume] = useState<number>(getMute() ? 0 : getVolume())
  const [isMute, setIsMute] = useState<boolean>(getMute())

  useEffect(() => {
    if (!player || !Number.isInteger(volume)) return

    setIsMute(volume <= 0)

    player.setVolume(volume)
  }, [player, volume])

  useEffect(() => {
    setPlayerMute(isMute)
  }, [isMute])

  return (
    <li className="ty01">
      <a
        href="#!"
        className={`sound ${volume <= 0 ? "mute" : ""} `}
        title="음량"
        onClick={(e: MouseEvent) => {
          e.preventDefault()
          setVolume(!isMute ? 0 : getVolume())
          setIsMute(!isMute)
        }}
      >
        음량
      </a>
      <Slider
        min={0}
        max={100}
        dots={false}
        value={volume}
        railStyle={{ height: "2px", backgroundColor: "#505050" }}
        trackStyle={{ height: "2px", backgroundColor: "#fff" }}
        handleStyle={{
          border: "0px",
          width: "8px",
          height: "8px",
          marginTop: "-3px",
        }}
        onChange={(value: number) => {
          setVolume(value)
        }}
        onAfterChange={(value: number) => {
          if (value <= 0) return

          setPlayerVolume(value.toString())
        }}
        tipFormatter={(value) => `${value}%`}
      />
    </li>
  )
}

const getVolume: () => number = () => {
  return getPlayerVolume() ? Number(getPlayerVolume()) : 100
}

const getMute: () => boolean = () => {
  return getPlayerMute() && getPlayerMute() === "on" ? true : false
}
